import React from "react";
import { useSelector } from "react-redux";
import Billdetails from "./Billdetails";
import CartItem from "./CartItem";

export default function Container() {
  const cartItems = useSelector((state) => state.cart);
  const products = useSelector((state) => state.products);

  const CartProducts = products.filter((item) =>
    cartItems.some((cartItem) => cartItem.id === item.id)
  );

  return (
    <>
      <div className="container 2xl:px-8 px-2 mx-auto">
        <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
        <div className="cartListContainer">
          <div className="space-y-6">
            {CartProducts.length > 0 ? (
              CartProducts.map((product) => {
                return (
                  <CartItem
                    key={product.id}
                    cartItems={cartItems}
                    product={product}
                  />
                );
              })
            ) : (
              <p>Cart is empty</p>
            )}
          </div>
          <Billdetails CartProducts={CartProducts} />
        </div>
      </div>
    </>
  );
}
